<app-profile-sub-header path="Invoices" text="View / download your previous invoices and transactions below"></app-profile-sub-header>

<table class="table table-borderless">
    <thead>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Description</th>
        <th scope="col">Total</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let invoice of invoices">
        <th scope="row" class="head">{{ formatDate(invoice?.createdAt) }}</th>
        <td class="des">{{ invoice?.details?.ticket?.name }}</td>
        <td class="head">{{ invoice?.cart?.totalDue | currency }}</td>
      </tr>
    </tbody>
  </table>
